<template>
  <div class="sp-template">
    <div class="h-title">货物签收</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择产品">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40805)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(40805)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(40803)" label="待处理" name="0"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40804)" label="完成" name="1"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <el-button v-show="in_configs(40801) && queryForm.status == 0" size="small"  @click="batchDeliveryDone()">批量操作</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" @selection-change="handleOrderSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.product]}}
          </template>
        </el-table-column>
        <el-table-column prop="refNumber" label="客户单号"></el-table-column>
        <el-table-column prop="totalCarton" label="预报箱数"></el-table-column>
        <el-table-column label="转单号">
          <template slot-scope="scope">
            <p v-for="(d,i) in scope.row.masterTrackingNos" :key="i">{{d}}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="inWarehouseDate" label="入仓时间"></el-table-column> -->
        <el-table-column prop="createAt" label="预报时间"></el-table-column>
        <el-table-column v-if=" queryForm.status == 1 "   prop="operateAt" label="签收时间"></el-table-column>
        <el-table-column v-if=" queryForm.status == 1 "   prop="operator" label="操作人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <i class="el-icon-edit-outline" v-show="in_configs(40801) &&queryForm.status ==0" @click="handleEdit(scope.$index, scope.row)"></i> -->
            <el-button type="text" size="mini" v-show="in_configs(40802) && queryForm.status ==0" @click="showDoneDelivery(scope.row)">完成签收</el-button>
            <el-button type="text" size="mini" v-show="scope.row.trackingNos && scope.row.trackingNos.length >0" @click="showTrackingNumber(scope.row)">查看转单号</el-button>
            <!-- <i class="el-icon-view" @click="handleLook(scope.$index, scope.row)"></i> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <!-- 查看 -->
      <el-dialog title="订单信息" :visible.sync="dialogTableVisible">
        <el-form :model="measureData" size="small" inline>
          <el-form-item label="订单号" label-width="70px">{{measureData.orderId}}</el-form-item>
          <el-form-item label="货物箱数" label-width="70px">{{measureData.totalCarton}}</el-form-item>
        </el-form>
        <el-table :data="measureData.details">
          <el-table-column property="cartonNumber" label="货箱编号"></el-table-column>
          <el-table-column label="长(cm)">
            <template slot-scope="scope">
              <span>{{scope.row.measureData.length}}</span>
            </template>
          </el-table-column>
          <el-table-column label="宽(cm)">
            <template slot-scope="scope">
              <span>{{scope.row.measureData.width}}</span>
            </template>
          </el-table-column>
          <el-table-column label="高(cm)">
            <template slot-scope="scope">
              <span>{{scope.row.measureData.height}}</span>
            </template>
          </el-table-column>
          <el-table-column label="重量(kg)">
            <template slot-scope="scope">
              <span>{{scope.row.measureData.weight}}</span>
            </template>
          </el-table-column>
          <el-table-column label="体积(c㎡)">
            <template slot-scope="scope">
              <span>{{scope.row.measureData.length*scope.row.measureData.width*scope.row.measureData.height}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="明细" :visible.sync="showTrackingNumberWindow">
        <p v-for="(d,i) in trackingNumbers" :key="i">{{d}}</p>
      </el-dialog>
      <!-- 完成派送的时间 -->
      <el-dialog title="派送信息" :visible.sync="showDeliveryDialog" width="450px">
        <div>
          签收日期：
          <el-date-picker v-model.lazy="deliveryDate" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="签收日期"></el-date-picker>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="showDeliveryDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="doneDelivery">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
        <el-form :model="form" size="small">
          <el-form-item label="客户名称" :label-width="formLabelWidth">{{form.test}}</el-form-item>
          <el-form-item label="订单号" :label-width="formLabelWidth">{{form.test}}</el-form-item>
          <el-form-item label="派送箱数" :label-width="formLabelWidth">
            <el-input v-model.lazy="form.test" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="派送公司" :label-width="formLabelWidth">
            <el-input v-model.lazy="form.test" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTrackingNumberWindow: false,
      trackingNumbers: [],
      orderIds: "",
      queryForm: {
          warehouseIds: [],
        orderIds: [],
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      tableData: [{}],
      measureData: {
        orderId: "",
        totalCarton: 0,
        details: [
          {
            cartonNumber: "",
            measureData: {
              length: 0,
              width: 0,
              height: 0,
              weight: 0
            }
          }
        ]
      },
      warehouses:[],
        warehouseMap: {},
      dialogTableVisible: false,
      form: {
        test: "666"
      },
      deliveryDate: "",
      deliveryOrderSelection: [],
      deliveryOrderId: [],
      showDeliveryDialog: false,
      formLabelWidth: "120px",
      dialogFormVisible: false,
      multipleSelection: [],
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1 //当前页
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {},
  methods: {
    showTrackingNumber(row) {
      let _this = this;
      this.showTrackingNumberWindow = true;
      this.trackingNumbers = row.trackingNos;
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllWarehouse(),
        this.findAllChannle(),
        this.findAllCustomerName()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(warehouseData, channelData, customerData) {
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          _this.initCustomerData(customerData);
          _this.query();
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
        _this.warehouses.forEach(a => {
            _this.warehouseMap[a.id] = a.name;
        });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
          {
            withCredentials: true
          }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
          {
            withCredentials: true
          }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
          {
            withCredentials: true
          }
      );
    },
    reset() {
      this.orderIds = ""
      this.queryForm = {
        warehouseIds: [],
        orderIds: [],
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      }
      this.searchTask()
    },
    //搜索
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    query() {
        let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
                wlist = _this.queryForm.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }

      this.$request1({
        method: 'post',
        url: '/operation/delivery/query',
        withCredentials: true,
        data: {
          orderIds: this.queryForm.orderIds,
          refNumbers: this.queryForm.refNumbers,
          customerIds: this.queryForm.customerIds,
          productIds: this.queryForm.productIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
            warehouseIds: wlist
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.total = data.total;
            if (this.total > 0) {
              this.tableData = taskData;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },

    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      console.log(index, row);
    },
    //完成派送
    showDoneDelivery(row) {
      this.deliveryOrderId = [];
      this.deliveryOrderId.push(row.orderId);
      this.deliveryDate = new Date();
      this.showDeliveryDialog = true;
    },
    doneDelivery() {
      if (this.deliveryDate == "" || this.deliveryDate == null) {
        this.$message.error("请选择派送时间");
        return;
      }
      if (this.deliveryOrderId.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.showDeliveryDialog = false;
      this.$request1({
        method: 'POST',
        url: '/operation/delivery',
        data: {
          orderIds: this.deliveryOrderId,
          deliveryDate: this.formateDateTime(this.deliveryDate)
        },
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$message.success("操作成功");
            this.query();
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    handleOrderSelectionChange(val) {
      this.deliveryOrderSelection = val;
      console.log(this.deliveryOrderSelection);
    },
    //批量派送
    batchDeliveryDone() {
      if (this.deliveryOrderSelection.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.deliveryOrderId = [];
      this.deliveryOrderSelection.forEach((select, index) => {
        this.deliveryOrderId.push(select.orderId);
      });
      this.deliveryDate = new Date();
      this.showDeliveryDialog = true;
    },
    formateDateTime(date) {
      return (
        new Date(date).getFullYear() +
        "-" +
        ("0" + (new Date(date).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(date).getDate()).slice(-2) +
        " " +
        ("0" + new Date(date).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(date).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(date).getSeconds()).slice(-2)
      );
    },
    // XXX 查看箱明细
    handleLook(index, row) {
      console.log(index, row);
      this.dialogTableVisible = true;
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/goodstosend.vue